import usePluginEntities from 'hooks/usePluginEntities';
import useSelectedDataLake from 'data-lake/hooks/useSelectedDataLake';

const useCurrentDataLakePlugin = () => {
  const dataLakePlugins = usePluginEntities('dataLakeStorageTypes');
  const { selectedDataLake } = useSelectedDataLake();

  return dataLakePlugins.find(({ storageType }) => selectedDataLake.storageType === storageType);
};

export default useCurrentDataLakePlugin;
